<template lang="pug">
    .row
        .col.s12
            p.title.medium {{action}} Order Items of {{orderReferenceNumber}}
            p.subtitle.small Please provide a reason/justification
            .input-field
                textarea.materialize-textarea(v-model='issue')
        .col.s12
            a.btn-flat.right.waves-effect(@click='onCancel') Cancel
            a.btn.red.darken-2.right.waves-effect(:class='{disabled: issue.length === 0}', @click='onConfirm(issue)') Confirm
</template>
<script>
export default {
  props: ['action', 'orderReferenceNumber', 'onCancel', 'onConfirm'],
  data () {
    return {
      issue: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/app-confirm-modal-content.vue